export const perfil = {
    GERAL: 0,
    UABS: 1,
    GESTOR: 2,
    GERENTE: 3,
    APOIO: 4,
    FORNECEDOR: 5,
    FINANCEIRO: 6
}